import React, { useState, useEffect, useRef } from 'react';
import { Send } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import SideBar1 from '../chats/sidebar1';

import HomeHeader1 from '../../components/HomeHeader1';
export default function HomePageTFT() {

  const school_type = localStorage.getItem("school_type");
  const [input, setInput] = useState('');
  const navigate = useNavigate();
  const textareaRef = useRef(null);


  // Adjust textarea height when content changes (profile load or user type)
  useEffect(() => {
    const el = textareaRef.current;
    if (!el) return;
    el.style.height = 'auto';
    el.style.height = Math.min(el.scrollHeight, 200) + 'px';
  }, [input]);
 const handleSend=()=>{
console.log(input)
// navigate("/afterchatbot")
navigate("/afterchatbot", { state: { input, fromTFT: true }});

 }

  return (
    <>
          <SideBar1/>

    <div style={styles.container}>
      {/* Header */}

      {/* <header style={styles.header}>
        <div style={styles.headerLeft}>
          <div style={styles.logo}>
            <Sparkles size={20} color="white" />
          </div>
          <span style={styles.logoText}>AI Assistant</span>
        </div>
        <button style={styles.newChatBtn}>
          New Chat
        </button>
      </header> */}
        <HomeHeader1/>
        {/* <div className='welcome-main-teaching'> */}
          
       <div className={school_type === "tft" ? "welcome-main-teaching" : "welcome-tft-main"}>
{/* <div className='welcome-teaching'>Welcome to Teaching For Transformation</div> */}

      {/* Main Content */}
      <main style={styles.main}>
        <div style={styles.content}>
          {/* Welcome Message */}

          <div style={styles.welcomeSection}>
            <h1 style={styles.welcomeTitle}>
            Welcome to Teaching For Transformation
            </h1>
            <p style={styles.welcomeSubtitle}>
           How can I help you today?
            </p>
          </div>

          {/* Input Area - Centered */}
          <div style={styles.inputWrapper}>
            <div style={styles.inputContainer}>
              <textarea
                ref={textareaRef}
                value={input}
                onChange={(e) => setInput(e.target.value)}
                placeholder="Ask a question or describe what you need..."
                rows={1}
                style={styles.textarea}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' && !e.shiftKey) {
                    e.preventDefault();
                    if (input.trim()) handleSend();
                  }
                }}
                onInput={(e) => {
                  const t = e.target;
                  t.style.height = 'auto';
                  t.style.height = Math.min(t.scrollHeight, 200) + 'px';
                }}
              />
              <button 
                style={{
                  ...styles.sendBtn,
                  // opacity: input.trim() ? 1 : 0.5,
                  cursor: input.trim() ? 'pointer' : 'not-allowed'
                }}
                disabled={!input.trim()}
                onClick={handleSend}
              >
                <Send size={20} />
              </button>
            </div>
            {/* <p style={styles.disclaimer}>
              AI can make mistakes. Check important info.
            </p> */}
          </div>

          {/* Suggestion Cards */}
          {/* <div style={styles.suggestionsGrid}>
            {suggestions.map((suggestion, idx) => (
              <button
                key={idx}
                onClick={() => setInput(suggestion)}
                style={styles.suggestionCard}
                onMouseEnter={(e) => {
                  e.currentTarget.style.borderColor = '#fb923c';
                  e.currentTarget.style.boxShadow = '0 4px 6px -1px rgba(0, 0, 0, 0.1)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.borderColor = '#e5e7eb';
                  e.currentTarget.style.boxShadow = 'none';
                }}
              >
                <div style={styles.suggestionContent}>
                  <MessageSquare size={20} color="#f97316" style={{ marginTop: '2px', flexShrink: 0 }} />
                  <span style={styles.suggestionText}>{suggestion}</span>
                </div>
              </button>
            ))}
          </div> */}
        </div>
      </main>
    </div>
     </div>
    </>
  );
}

const styles = {
  container: {
    minHeight: '100vh',
    // background: 'linear-gradient(to bottom right, #fef3c7, #ffffff, #ffedd5)',
    // background: 'linear-gradient(to bottom right, #2c68a1, #5a8fcf, #d0e2f7)',
    // background: 'linear-gradient(to bottom right, #a3c3f0,rgb(237, 243, 250),rgb(180, 201, 230))',

    display: 'flex',
    flexDirection: 'column',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
  },
  header: {
    padding: '16px 24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: '1px solid #e5e7eb',
    backgroundColor: 'rgba(255, 255, 255, 0.8)',
    backdropFilter: 'blur(8px)'
  },
  headerLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  logo: {
    width: '32px',
    height: '32px',
    // background: 'linear-gradient(to bottom right, #fb923c, #d97706)',
    background: 'linear-gradient(to bottom right, #2c68a1, #5a8fcf)',

    borderRadius: '8px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  logoText: {
    fontWeight: '600',
    color: '#111827'
  },
  newChatBtn: {
    padding: '8px 16px',
    backgroundColor: '#111827',
    color: 'white',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: '500',
    border: 'none',
    cursor: 'pointer',
    transition: 'background-color 0.2s'
  },
  main: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '80%',
    padding: '24px',

  },
  content: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '32px'
  },
  welcomeSection: {
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    gap: '12px'
  },
  welcomeTitle: {
    fontSize: '35px',
    fontWeight: '700',
    color: '#000000',
    margin: 0,
    letterSpacing: '-0.025em'
  },
  welcomeSubtitle: {
    fontSize: '20px',
    color: '#2D333A',
    margin: 0
  },
  inputWrapper: {
    marginTop: '32px'
  },
  inputContainer: {
    position: 'relative',
    backgroundColor: 'white',
    border: '1px solid #d1d5db',
    borderRadius: '6px',
    boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
    transition: 'all 0.2s'
  },
  textarea: {
    width: '100%',
    padding: '16px 20px',
    paddingRight: '56px',
    backgroundColor: 'transparent',
    resize: 'none',
    border: 'none',
    outline: 'none',
    color: '#111827',
    fontSize: '16px',
    minHeight: '56px',
    maxHeight: '200px',
    fontFamily: 'inherit',
    boxSizing: 'border-box'
  },
  sendBtn: {
    position: 'absolute',
    right: '12px',
    bottom: '12px',
    width: '40px',
    height: '40px',
    backgroundColor: '#2C68A1',
    color: 'white',
    borderRadius: '12px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: 'none',
    transition: 'background-color 0.2s'
  },
  disclaimer: {
    fontSize: '20px',
    color: '#6B6B6C',
    textAlign: 'center',
    marginTop: '12px'
  },
  suggestionsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(40%, 1fr))',
    gap: '12px',
    marginTop: '32px'
  },
  suggestionCard: {
    padding: '16px',
    textAlign: 'left',
    backgroundColor: 'white',
    border: '1px solid #e5e7eb',
    borderRadius: '12px',
    cursor: 'pointer',
    transition: 'all 0.2s',
    fontFamily: 'inherit'
  },
  suggestionContent: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '12px'
  },
  suggestionText: {
    color: '#374151',
    fontWeight: '500',
    fontSize: '15px'
  }
};